import { render } from "./EntraIntuneAppProtection.vue?vue&type=template&id=68b20853&scoped=true"
import script from "./EntraIntuneAppProtection.vue?vue&type=script&lang=js"
export * from "./EntraIntuneAppProtection.vue?vue&type=script&lang=js"

import "./EntraIntuneAppProtection.vue?vue&type=style&index=0&id=68b20853&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b20853"]])

export default __exports__